import React from 'react'

export default function FilterIcon({ className }) {
  return (
    <svg className={className} version="1.1" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 1024 1024">
      <path fill="#ffffff" d="M386.695 520.014l-386.695-331.368v-188.646h1004.957v188.646l-392.602 336.384v389.164l-219.792 109.806v-498.97z"></path>
    </svg>
  )
}



// WEBPACK FOOTER //
// ./src/components/ui-ant/Datatable/filterIcon.js